import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { TESTIMONIALS, TESTIMONIALS_ENABLED, GOOGLE_TRUST } from "@/lib/testimonials";

function Card({ t, testid }) {
  return (
    <figure data-testid={testid} className="bg-noir p-8 md:p-10 h-full flex flex-col">
      <blockquote className="font-serif text-lg md:text-xl font-light leading-relaxed text-white/85 flex-1">
        &ldquo;{t.quote}&rdquo;
      </blockquote>
      <figcaption className="mt-8 font-body text-[11px] uppercase tracking-[0.2em] text-white/45">
        Verified Google Review — <span className="text-gold">{t.initials}</span>
      </figcaption>
    </figure>
  );
}

export default function Testimonials() {
  const [more, setMore] = useState(false);
  if (!TESTIMONIALS_ENABLED || TESTIMONIALS.length === 0) return null;
  const main = TESTIMONIALS.slice(0, 3);
  const extra = TESTIMONIALS.slice(3);
  return (
    <section data-testid="testimonials" className="py-24 md:py-32 px-6 md:px-12 bg-noir">
      <div className="max-w-[1500px] mx-auto">
        <Reveal className="text-center mb-14">
          <p className="font-body text-[11px] uppercase tracking-[0.4em] text-gold mb-6">Travelers Say It Best</p>
          <p data-testid="google-trust-line" className="font-body text-sm text-gold/90 font-light">{GOOGLE_TRUST}</p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {main.map((t, i) => (
            <Reveal key={t.initials} delay={i * 0.08} className="h-full"><Card t={t} testid={`testimonial-${i + 1}`} /></Reveal>
          ))}
        </div>

        {extra.length > 0 && (
          <>
            {more && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10 border-t-0" data-testid="testimonials-more">
                {extra.map((t, i) => (
                  <Reveal key={t.initials} className="h-full"><Card t={t} testid={`testimonial-${i + 4}`} /></Reveal>
                ))}
              </div>
            )}
            <div className="text-center mt-8">
              <button data-testid="testimonials-toggle" onClick={() => setMore(!more)} aria-expanded={more}
                className="inline-flex items-center gap-2 font-body text-[11px] uppercase tracking-[0.22em] text-gold hover:text-ink transition-colors">
                {more ? "Show Fewer Reviews" : "More Traveler Reviews"}
                <ChevronDown size={14} className={`transition-transform duration-300 ${more ? "rotate-180" : ""}`} />
              </button>
            </div>
          </>
        )}

        <p data-testid="testimonials-disclosure" className="text-center font-body text-[11px] text-white/35 mt-10 font-light">
          Paraphrased from verified Google reviews.
        </p>
      </div>
    </section>
  );
}
